import axios, { AxiosError } from 'axios';

import i18next from '@/i18n';

import { type CloseNotification, SYSTEM_ACTIONS, bridge } from './vendor/web';

export const nativeLog = (message: string, data?: unknown): void => {
  bridge.send(SYSTEM_ACTIONS.Log, { message, data });
};

export const closeWebView = (reason?: CloseNotification): void => {
  bridge.send(SYSTEM_ACTIONS.NavigationClose, reason ? { reason } : null);
};

const SSO_AUTHORIZE_TIMEOUT = 5 * 60 * 1000; // 5 minutes
export const ssoAuthorize = async (): Promise<{
  status: number;
  data: { accessToken: string };
} | null> => {
  try {
    const bridgeResponse = await bridge.request<{
      authorizationCode: string;
      codeVerifier: string;
      expiresInSeconds: number;
    }>(SYSTEM_ACTIONS.SsoAuthorize, null, SSO_AUTHORIZE_TIMEOUT);
    const response = await axios.post(
      process.env.PUBLIC_API_URL + '/online/auth/superapp',
      { sessionToken: bridgeResponse.authorizationCode }
    );
    return response;
  } catch (err) {
    const error = err as AxiosError;
    const errorMessage =
      error.response?.status && error.response.status >= 500
        ? i18next.t('errors.generic')
        : error.message;
    closeWebView({
      type: 'error',
      message:
        error.response?.status === 401
          ? i18next.t('auth.notifications.loginErrorTitle')
          : errorMessage
    });
    return null;
  }
};

export const redirectToMiniApp = (
  miniAppId: 'auto-credit',
  params?: Record<string, unknown>
) => {
  bridge.send(SYSTEM_ACTIONS.NavigationOpenMiniApp, { miniAppId, params });
};
